/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button, message } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView } from 'Components';
import { list, createAccount } from '../../service/channel/linkman';
import { accountResetPwd, accountInvalid } from '../../service/account';
import {LinkmanActions as Actions, LinkmanStore as Store} from './store';

class LinkmanList extends Reflux.Component {
  constructor (props) {
    super(props);
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      channelId: parseInt(this.props.params.channelId, 10),
      filterBoxVisible: false,
      rows: [],
      total: 0,
      searchObj: {
        channelId: parseInt(this.props.params.channelId, 10),
        s: 10,
        p: 1,
      }
    };
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if(path[1] === 'staff' && path[3] !== 'add'){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange(this.state.searchObj);
    }else{
      Actions.useStoreChange(false);
      Actions.paramChange({});
    }
  }
  componentWillMount () {
    const data = this.store.state;
    if (data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params,
        }
      });
    }
  }
  componentDidMount() {
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  getData () {
    const self = this;
    list({ ...this.state.searchObj }).then(res => {
      self.setState({
        rows: res.data,
        total: res.total
      })
    })
  }
  createAccount (linkmanId) {
    const self = this;
    createAccount({ id: linkmanId }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getLinkman();
    })
  }
  invalidAccount(accountId){

    const self = this;
    accountInvalid({id: accountId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getData();
    })
  }
  resetPwd(accountId){

    const self = this;
    accountResetPwd({id: accountId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getData();
    })
  }

  goView (url) {
    hashHistory.push(url);
  }
  goBack () {
    hashHistory.goBack();
  }

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    });
  }

  render () {
    const self = this;
    const { rows, total, searchObj, channelId } = this.state;
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '姓名',
          dataIndex: 'name',
          render: (text, record, index) => <a href={`#/linkman/${channelId}/${record.id}`}>{text}</a>
        },
        {
          title: '性别',
          dataIndex: 'sexText',
        },
        {
          title: '手机',
          dataIndex: 'contactInfoList',
          render: (arr, record, index) => {
            if (arr) {
              let list = arr.filter(x => x.type == 1);
              return list.length ? list[0].content : ''
            }
            return ''
          }
        },
        {
          title: '岗位',
          dataIndex: 'post',
        },
        {
          title: '账号',
          dataIndex: 'userId',
          render: (userId, record, index) => {
            if (userId && record.contactInfoList) {
              let list = record.contactInfoList.filter(x => x.type == 1);
              return list.length ? list[0].content : ''
            }
            return ''
          }
        },
        {
          title: '操作',
          dataIndex: '',
          width: '200px',
          render: (text, record, index) => record.userId ? <span>
            <a onClick={self.invalidAccount.bind(self, record.userId)}>禁用账号</a>&nbsp;&nbsp;&nbsp;
            <a onClick={self.resetPwd.bind(self, record.userId)}>重置密码</a>
          </span> : <span>
            <a onClick={self.createAccount.bind(self, record.id)}>开通账号</a>
          </span>
        },
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={['全部联系人']} defaultKey={0}>
        <Button icon="plus" onClick={this.goView.bind(this, `/staff/${this.props.params.storeId}/add/0`)}>新增</Button>
        <Button onClick={this.goBack}>返回</Button>
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
;
export default withRouter(LinkmanList);


// WEBPACK FOOTER //
// ./src/routes/linkman/list.js